import { type ProjectCode } from '@constants'
import { type WpOrderStatus, WP_ORDER_STATUS } from '@hooks-api/types/dataModel/eCommerceOrders'
import { createContext, useContext } from 'react'

export interface ContextWpMyAccountProps {
  environment: 'wordPress' | 'merchant' | 'campaign'
  orderStatus: WpOrderStatus
  projectCode?: ProjectCode
  campaignId?: number
}

export const WpMyAccountContext = createContext<ContextWpMyAccountProps>({
  environment: 'wordPress',
  orderStatus: WP_ORDER_STATUS.PENDING,
})

export function useContextWpMyAccount() {
  const wpMyAccountContext = useContext(WpMyAccountContext)

  if (!wpMyAccountContext) throw new Error('useContextWpMyAccount has to be used within <useContextWpMyAccount.Provider>')

  return wpMyAccountContext
}
